<template>
  <div class="my-allContent">
    <div class="editorContent">
      <p class="comment_title">
        <input
          type="text"
          v-model="state.title"
          placeholder="请输入标题(选填,最多20字)"
          maxlength="20"
        />
      </p>
      <Editor
        v-model="valueHtml"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onChange="onChange"
        @onCreated="handleCreated"
      />
    </div>
    <div class="toolContent">
      <Toolbar
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />

      <van-button
        class="publishComment"
        round
        :disabled="publishFlag"
        @click="publishComment"
        >发布</van-button
      >
    </div>
  </div>
</template>
<script setup>
import "@wangeditor/editor/dist/css/style.css"; // 引入 css

import {
  onBeforeUnmount,
  ref,
  shallowRef,
  onMounted,
  onDeactivated,
  onActivated,
  reactive,
  nextTick,
} from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
// 获取发布评论的api
import { addComment, getCommentType } from "@/api/yzCommunity";
import store from "@/store";
import router from "@/router";
import { Toast } from "vant";
import { enCodeEmoji, checkmaskWords } from "@/utils/emojiToCode";

const state = reactive({
  gid: "",
  username: "",
  uid: "",
  commentType: "",
  title: "",
});

const mode = "simple";
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("<p></p>");

// 模拟 ajax 异步获取内容
onMounted(() => {
  //   valueHtml.value = ''
});

const toolbarConfig = {
  toolbarKeys: [
    "uploadImage", // 上传图片
    "emotion", // 表情
    "bold", // 加粗
    "italic", // 斜体
  ],
};

const editorConfig = {
  placeholder: ` 围绕游戏的画面、玩法、操作、氪金等等方面发表你对游戏的看法和体验!可以从以下方面着手：
           1.客观、理性的有价值内容 2.游戏实用略、心得技巧 3.游戏相关的深度评测 .... 包含但不限于以上，但必须是原创、真实、客观的内容哦~ (小道消息：优质内容将有机会获得10~30积分奖励哦QVQ) 胡乱发布垃圾信息或广告等将会被取消发布权限！
          `,
  MENU_CONF: {
    // 上传图片
    uploadImage: {
      // 上传之前触发
      onBeforeUpload(files) {
        // console.log('图片数据---------------------',files)
      },
      //base64LimitSize: 5 * 1024, //1mb base64大小限制
      maxFileSize: 20 * 1024 * 1024, // 1M
      // 上传图片到服务器
      server: "http://hzzksq.5535.cn/box/Comments/imagesupolad",
      // 上传进度
      onprogress: (event, xhr, editor) => {
        // 上传进度回调
        // console.log('上传进度', event)
        // console.log('xhr', xhr)
        // console.log('editor', editor)
      },
      // 上传成功
      onSuccess(file, res) {
        // console.log(`${file.name} 上传成功`, res)
      },
      // 单个文件上传失败
      onFailed(file, res) {
        // JS 语法
        console.log(`${file.name} 上传失败`, res);
      },

      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        // JS 语法
        // console.log(`${file.name} 上传出错`, err, res)
      },
    },
  },
};

// 获取组件传过来的值
const props = defineProps({
  gid: {
    type: String,
    default: "",
  },
  commentType: {
    type: Number || String,
    default: "",
  },
  username: {
    type: String,
    default: "",
  },
  uid: {
    type: String,
    default: "",
  },
});
const { emit } = defineEmits(["publish"]);

onActivated(() => {
  valueHtml.value = "";
  state.title = "";

  // 打印组件传过来的值
  setTimeout(() => {
    // console.log(props.gid)
    state.username = store.state.mobile;
    state.uid = store.state.id;
  }, 300);
  // 初始化编辑器
  nextTick(() => {
    // handleCreated()
  });
});

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

const publishFlag = ref(false);
const onChange = () => {
  // 去除html标签
  let minLength = valueHtml.value;
  minLength = minLength.replace(/<[^>]+>|&nbsp;/g, "").trim();

  publishFlag.value = minLength.length < 4 ? true : false;
};

// 发布评论
const publishComment = () => {
  if (checkmaskWords(state.title) || checkmaskWords(valueHtml.value)) {
    valueHtml.value = "";
    state.title = "";
    return;
  }
  // valueHtml.value=enCodeEmoji(valueHtml.value)
  // 将输入框的表情转换为对应的字符串
  // console.log('输入框的内容',valueHtml.value)

  let formData = new FormData();
  formData.append("gid", props.gid);
  formData.append("content", encodeURI(enCodeEmoji(valueHtml.value)));
  formData.append("pid", "");
  formData.append("username", props.mobile);
  formData.append("uid", props.uid);
  formData.append("ctype", props.commentType);
  formData.append("title", encodeURI(state.title));
  //   console.log('发布评论的数据-----------------',formData.get('type'))
  addComment(formData).then((response) => {
    // console.log('发布评论返回的数据-----------------',response)
    if (response.data.a == "1") {
      //  清空编辑器内容
      state.title = "";
      valueHtml.value = "";
      Toast.success("发布成功,请等待审核～");
    } else {
      Toast.fail(response.data.b);
    }
  });
};
</script>
<style scoped>
.my-allContent {
  height: 100%;
}
/* 测试修改 */
.my-allContent :deep(.editorContent) {
  min-height: 300px;
}
.my-allContent :deep(.w-e-text-container) {
  background-color: #090f1a;
  border-radius: 20px;
  /* height: 1188px; */
}
.toolContent {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  width: 100%;
}
.toolContent .publishComment {
  width: 176px;
  height: 68px;
  background-color: #12cec7;
  border-radius: 34px;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}
.toolContent :deep(.w-e-toolbar) {
  width: 344px;
  height: 68px;
  background-color: #fff;
  border-radius: 198px;
  display: flex;
  justify-content: center;
}
.toolContent :deep(.w-e-toolbar) > div {
  height: 100%;
}
.toolContent :deep(.w-e-bar-item button) {
  height: 100%;
}
.toolContent :deep(.w-e-bar svg) {
  width: 44px;
  height: 44px;
}
.my-allContent .editorContent > div {
  /* height: 500px!important; */
  overflow: auto;
  font-size: 24px;
}
.toolContent :deep(.w-e-drop-panel) {
  top: auto;
  bottom: 80px;
  background: #202430;
  border: none;
  box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 0.08),
    0px -2px 4px 0px rgba(255, 255, 255, 0.08);
}
.toolContent :deep(.w-e-panel-content-emotion) {
  width: 500px;
  height: 200px;
  overflow: auto;
  font-size: 50px;
}
.toolContent :deep(.w-e-menu-tooltip-v5:before) {
  z-index: -2;
}
.toolContent :deep(.w-e-bar-item .active) {
  background-color: #1f2430;
}
:deep(.w-e-bar-item button:hover) {
  background-color: #1f2430;
}
.toolContent :deep(.w-e-bar-item .active svg) {
  fill: #12cec7;
}

.my-allContent :deep(.w-e-text-container) img {
  max-width: 400px;
}

.my-allContent :deep(.w-e-scroll) {
  /* height: 500px!important; */
  min-height: 300px;
  overflow: auto;
}

/* 测试修改 */
:deep(.editorContent) > div {
  min-height: 300px !important;
  max-height: 800px !important;
}
.my-allContent :deep(.w-e-text-container) {
  min-height: 300px;
}
.my-allContent :deep(.w-e-scroll) > div {
  min-height: 500px;
  background-color: #fff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  /* border-radius: 20px; */
  color: #333;
}

/* 帖子标题 */
.my-allContent .editorContent .comment_title {
  outline: none;
  border: none;
  padding: 20px 20px;
  background-color: #fff;
  width: 686px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}
.my-allContent .editorContent .comment_title input {
  border: none;
  border-bottom: 2px solid #909197;
  width: 100%;
  padding-bottom: 12px;
  background-color: #fff;
  font-size: 36px;
  font-weight: 800;
  color: #333;
}
input::placeholder {
  color: #999;
}
</style>
